// TABLES HAS TO HAVE HEADER SECTION FUNCTION
// TURNED ON
// AND ALSO HAVE RESPONSIVE TABLE STYLE ENABLED

(function () {

    function initTables() {
        let tables = document.querySelectorAll('.is-style-responsive-table');

        if (tables.length) {
            tables.forEach(function (table) {
                let rows = table.querySelectorAll('tbody tr');
                let headers = table.querySelectorAll('th');

                if (rows.length) {
                    rows.forEach(function (row) {
                        addLabels(row, headers);
                    });
                }
            });
        }
    }

    function addLabels(row, headers) {
        let columns = row.querySelectorAll('td');

        if (columns.length) {
            columns.forEach(function (column, index) {
                column.setAttribute('data-label', headers[index].innerHTML);
                let content = column.innerHTML;
                column.innerHTML = '<span>' + content + '</span>';
            });
        }
    }


    window.addEventListener('load', function () {
        initTables();
    });
})();


//////////////////
// WEBPACK FOOTER
// ./js/modules/tables.js
// module id = 24
// module chunks = 0